import { render, staticRenderFns } from "./formThreads.vue?vue&type=template&id=20268c50"
import script from "./formThreads.vue?vue&type=script&lang=js"
export * from "./formThreads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20268c50')) {
      api.createRecord('20268c50', component.options)
    } else {
      api.reload('20268c50', component.options)
    }
    module.hot.accept("./formThreads.vue?vue&type=template&id=20268c50", function () {
      api.rerender('20268c50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/standardTab/formNetwork/formThreads.vue"
export default component.exports